<template>
  <div class="shop-header" v-if="safeShop">
    <div class="info">
      <div class="logo">
        <img :src="safeShop.logo" />
      </div>
      <div class="shop-base">
        <div style="position: absolute; right: 5px;top: -5px;width: 80px;">
          <van-button type="danger" size="small" round block
          @click="$router.push(
        {
          name: 'shop',
          query: {
            id: safeShop.id
          }
        },
        () => {}
      )"
            >进店</van-button
          >
        </div>
        <p class="name">{{ safeShop.name }}</p>
        <div class="desc">
          <div class="star">
            <van-icon
              :name="i <= safeShop.star ? 'star' : 'star-o'"
              v-for="i in 5"
              :key="i"
              color="#faab0c"
            />
            {{ safeShop.star }}
          </div>
          <div class="quantity">{{ safeShop.collection_quantity }} 收藏</div>
          <div class="quantity">{{ safeShop.positive_review }} 好评</div>
        </div>
      </div>
    </div>
    <div class="remark">
      <p class="title">{{ safeShop.title }}</p>
      <div class="bewrite">{{ safeShop.bewrite }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopView',
  props: ['shopdata'],
  computed: {
    safeShop () {
      return this.shopdata || null
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.shop-header {
  margin: 10px 10px 10px;
  padding: 15px 0px 0px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .info {
    display: flex;
    gap: 10px;
    margin: 0px 12px;
    .logo {
      width: 50px;
      height: 50px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .shop-base {
      flex: 1;
      position: relative;
      margin-bottom: 10px;
      .name {
        font-size: 20px;
        font-weight: 600;
      }
      .desc {
        display: flex;
        gap: 10px;
        font-size: 14px;
        margin-top: 5px;
        .star {
          height: 18px;
          line-height: 18px;
          flex: 1;
          color: #faab0c;
        }
        .quantity {
          height: 18px;
          line-height: 18px;
          flex: 1;
          color: #faab0c;
        }
      }
    }
  }
  .remark {
    background: #daecf7;
    padding: 10px 15px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    p.title {
      font-weight: 600;
      margin: 8px 0;
    }
    .bewrite {
      font-size: 14px;
      color: #969799;
    }
  }
}
</style>
